import { Dashboard, PageLayout } from '@components/common';
import { SECTION_NAMES } from '@constants/sectionNames';
import { HeadContent } from '@fourthwall/components';
import React from 'react';
import { AnalyticsToolbar, PrecisionSelect, RangeSelect } from '../../modules/AnalyticsParams';
import { AnalyticsReportsData, } from './components/AnalyticsReportsData/AnalyticsReportsData';
export const AnalyticsReportsView = ({ list, table }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadContent, { title: SECTION_NAMES.analyticsReports }),
        React.createElement(PageLayout, null,
            React.createElement(Dashboard.Section, { name: SECTION_NAMES.analyticsReports },
                React.createElement(AnalyticsToolbar, null,
                    React.createElement(RangeSelect, null),
                    React.createElement(PrecisionSelect, null)),
                React.createElement(AnalyticsReportsData, { list: list, table: table })))));
};
